var isNext = true;
const updateContent = (nextSlide = 0) => {
    const $slide = $(`.banner-top .slider .item[data-slick-index='${nextSlide}']`);
    const content = $slide.find(".text-content").html();
    const newColor = $slide.data("color");
    const newImage = $slide.data("image");

    const oldTextbox = $(".banner-top .text-wrapper .text-box");
    const newTextBox = $(".banner-top .text-wrapper .text-box").first().clone();

    newTextBox.find(".content").html(content);
    $(".banner-top .background-green").css("background-color", newColor);
    $(".banner-top .flower").css("background-image", `url(${newImage})`);

    if (isNext) {
        newTextBox.insertAfter(oldTextbox)
        anime({
            targets: newTextBox[0],
            duration: 500,
            opacity: [0, 1],
            rotate: [10, -4],
            easing: 'linear',
            complete: function () {
                oldTextbox.remove()
            }
        })
    }
    else {
        isNext = true;
        newTextBox.insertBefore(oldTextbox);
        anime({
            targets: oldTextbox[0],
            duration: 500,
            opacity: [1, 0],
            rotate: [-4, 10],
            easing: 'linear',
            complete: function () {
                oldTextbox.remove()
            }
        })
    }
}

const program = () => {
    const $parent = $(".program-office");
    const $items = $parent.find(".category-item");
    $items.on("click", function () {
        $parent.find(".category-item.active").removeClass("active");
        $(this).addClass("active");
    })

    //xử lý khi chọn category program/office trên mobile
    $(".change-category").on("click", function () {
        if ($(window).width() > 1200) return;
        const type = $(this).data("type");
        $parent.find(`.category-child`).hide()
        $parent.find(`.category-child.${type}`).fadeIn()
        $parent.find(`.category-child.${type}`).find('.category-item')[0].click();
    })
    $($(".change-category")[0]).click()
}
const homepage = () => {
    if ($(".homepage").length) {
        $(".banner-top .slider").slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: true,
            // prevArrow: ".prev-btn",
            nextArrow: ".next-btn",
        }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {

            // console.log("change", nextSlide, currentSlide, event)
            updateContent(nextSlide)
        });
        $(".banner-top .prev-btn").on("click", function () {
            isNext = false;
            $(".banner-top .slider").slick("slickPrev");
        })
        updateContent();

        $('.logo-slide').slick({
            dots: $('.logo-slide-item').length > 8 ? true : false,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            rows: 2,
            slidesPerRow: 4,
            prevArrow: false,
            nextArrow: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        rows: 4,
                        slidesPerRow: 4,
                    }
                }
            ]
        });
        $('.list-img').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            speed: 500,
            dots: false,
            autoplay: true,
            prevArrow: $('#prev-slogan'),
            nextArrow: $('#next-slogan'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.list-document').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            speed: 500,
            dots: false,
            autoplay: true,
            prevArrow: $('#prev-doc'),
            nextArrow: $('#next-doc'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.play').click(function () {
            let myVideo = $(this).parents('.video-wrapper').find('video').get(0);
            if (myVideo.paused)
                myVideo.play();
            else
                myVideo.pause();
        });

        program();
    }
}

module.exports = homepage
